// extracted by mini-css-extract-plugin
export default {"header":"header_header__ifEYi","wrapper":"header_wrapper__GKh9P","hoverText":"header_hoverText__TuS9s"};